const getImmutable = (val:any) => Object.freeze(val);

export const emptyObject = getImmutable({});